import { Quote } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import clsx from 'clsx';

interface AssignmentKeyQuotesProps {
  quotes?: string | null;
  className?: string;
}

export function AssignmentKeyQuotes({
  quotes,
  className,
}: AssignmentKeyQuotesProps) {
  const items =
    quotes
      ?.split('\n')
      .map(q => q.trim())
      .filter(Boolean) || [];

  const hasQuotes = items.length > 0;

  return (
    <div className={clsx('w-full space-y-3 mt-4', className)}>
      {hasQuotes ? (
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 w-full'>
          {items.map((text, index) => (
            <Card key={index} className='p-3 w-full'>
              <CardContent className='p-0 flex flex-col gap-2'>
                <div className='flex items-start gap-2'>
                  <Quote className='h-4 w-4 mt-1 text-muted-foreground shrink-0' />
                  <p className='text-sm text-left leading-snug italic'>
                    “{text}”
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className='p-3 min-h-[80px]'>
          <div className='flex items-center justify-center p-0 h-full text-sm text-muted-foreground'>
            No key quotes available
          </div>
        </Card>
      )}
    </div>
  );
}
